export const UscColorProps = {
    black: "--color-black",
    midnight: "--color-midnight",
    white: "--color-white",
    red: "--color-red",
    green: "--color-green",
    "electrified-blue": "--color-electrified-blue",
    "sky-blue": "--color-sky-blue",
    "azure-hover": "--color-azure-hover",
    azure: "--color-azure",
    cloud: "--color-cloud",
    mist: "--color-mist",
    silver: "--color-silver",
    "platinum-light": "--color-platinum-light",
    "platinum-medium": "--color-platinum-medium",
    titanium: "--color-titanium",
    "brushed-steel": "--color-brushed-steel",
    "platinum-dark": "--color-platinum-dark",
    steel: "--color-steel",
    "eco-a": "--color-eco-a",
    "eco-b": "--color-eco-b",
    "eco-c": "--color-eco-c",
    "eco-d": "--color-eco-d",
    "eco-e": "--color-eco-e",
    "eco-f": "--color-eco-f",
    "eco-g": "--color-eco-g",
    "eco-default": "--color-eco-default",
};

export const UscSpacingProps = {
    "spacing-0": "--spacing-0",
    "spacing-1": "--spacing-1",
    "spacing-2": "--spacing-2",
    "spacing-3": "--spacing-3",
    "spacing-4": "--spacing-4",
    "spacing-5": "--spacing-5",
    "spacing-6": "--spacing-6",
    "spacing-7": "--spacing-7",
    "spacing-8": "--spacing-8",
    "spacing-9": "--spacing-9",
    "spacing-10": "--spacing-10",
    "spacing-11": "--spacing-11",
};

export type UscColorType = keyof typeof UscColorProps;
export type UscSpacingType = keyof typeof UscSpacingProps;
